import React, { useState } from 'react';
import styles from './Navbar.module.css';

function Navbar() {
  const [showLinks, setShowLinks] = useState(false);

  const toggleNavbarLinks = () => {
    setShowLinks(!showLinks);
    const toggleButton = document.querySelector(`.${styles.toggle_button}`);
    toggleButton.classList.toggle(`${styles.active}`);
  };

  const [fundacjaDropdownOpen, setFundacjaDropdownOpen] = useState(false);
  const [projektyDropdownOpen, setProjektyDropdownOpen] = useState(false);

  const toggleFundacjaDropdown = () => {
    setFundacjaDropdownOpen((prevState) => {
      if (!prevState && projektyDropdownOpen) {
        setProjektyDropdownOpen(false);
      }
      return !prevState;
    });
  };

  const toggleProjektyDropdown = () => {
    setProjektyDropdownOpen((prevState) => {
      if (!prevState && fundacjaDropdownOpen) {
        setFundacjaDropdownOpen(false);
      }
      return !prevState;
    });
  };

  const closeDropdowns = () => {
    setFundacjaDropdownOpen(false);
    setProjektyDropdownOpen(false);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbar_left}>
        <img
          src='img/sztuka_i_dom_logo-fundacja.png'
          alt='Logo'
          className={styles.logo}
        />
      </div>
      <ul className={`${styles.navbar_right} ${showLinks ? styles.show : ''}`}>
        <li>
          <a href='#aktualnosci'>Aktualności</a>
        </li>
        <li>
          <a href='#fundacja' onClick={toggleFundacjaDropdown}>
            Fundacja
          </a>
          {fundacjaDropdownOpen && (
            <ul className={styles.navbar_right_dropdown}>
              <li>
                <a href='#dane-urzedowe' onClick={closeDropdowns}> Dane urzędowe</a>
              </li>
              <li>
                <a href='files/statut_fundacja-sztuka-i-dom.pdf' onClick={closeDropdowns}> Statut</a>
              </li>
              <li>
                <a href='#o-nas' onClick={closeDropdowns}> O nas </a>
              </li>

              <li>
                <a href='#prezes' onClick={closeDropdowns}> Prezes</a>
              </li>
              <li>
                <a href='#wiceprezeska' onClick={closeDropdowns}> Wiceprezeska</a>
              </li>
              <li>
                <a href='#patron' onClick={closeDropdowns}> Patron</a>
              </li>
            </ul>
          )}
        </li>

        <li>
          <a href='#projekty' onClick={toggleProjektyDropdown}>
            Projekty
          </a>
          {projektyDropdownOpen && (
            <ul className={styles.navbar_right_dropdown}>
               <li>
                <a href='#dzialania' onClick={closeDropdowns}> Działania</a>
              </li>
              <li>
                <a href='#projekty-aktualne' onClick={closeDropdowns}> Projekty aktualne</a>
              </li>
              <li>
                <a href='#projekty-zrealizowane' onClick={closeDropdowns}> Projekty zrealizowane</a>
              </li>
            </ul>
          )}
        </li>
        <li>
          <a href='#galeria' onClick={closeDropdowns}>Galeria</a>
        </li>
        <li>
          <a href='#kontakt' onClick={closeDropdowns}>Kontakt</a>
        </li>
      </ul>
      <button
  type="button"
  className={styles.toggle_button}
  onClick={toggleNavbarLinks}
  aria-label="Otwórz menu"
>
  <span className={styles.bar}></span>
  <span className={styles.bar}></span>
  <span className={styles.bar}></span>
</button>
    </nav>
  );
}

export default Navbar;
